import { supabase } from "@/lib/supabase/supabaseClient";
import { useRestoreSurveyProps } from "./useRestoreSurvey.types";

export const restoreSurvey = async (survey_id: useRestoreSurveyProps) => {
    return await supabase.from('survey').update({archived: false}).eq('id', survey_id).select();
}
